var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0718 14.12C13.8034 14.4148 13.4797 14.6512 13.1201 14.8151C12.7605 14.9791 12.3722 15.0673 11.9786 15.0744C11.5849 15.0815 11.1939 15.0074 10.8288 14.8565C10.4638 14.7056 10.1322 14.4811 9.85376 14.1962C9.57536 13.9113 9.35588 13.572 9.20843 13.1984C9.06097 12.8249 8.98856 12.4247 8.99551 12.0219C9.00245 11.6191 9.08862 11.2219 9.24886 10.8539C9.4091 10.4859 9.64013 10.1547 9.92818 9.88003M17.805 17.94C16.1344 19.243 14.1003 19.9649 12 20C5.15909 20 1.25 12 1.25 12C2.46562 9.68192 4.15166 7.65663 6.195 6.06003L17.805 17.94ZM9.94773 4.24002C10.6204 4.0789 11.3091 3.99836 12 4.00003C18.8409 4.00003 22.75 12 22.75 12C22.1568 13.1356 21.4493 14.2048 20.6391 15.19L9.94773 4.24002Z",
    stroke: "#C3CBDC",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 1L23 23",
    stroke: "#C3CBDC",
    strokeWidth: 1.5,
    strokeLinejoin: "bevel"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOff);
export default __webpack_public_path__ + "static/media/eye-off.c505363398e3c56a2d219ea8ff417944.svg";
export { ForwardRef as ReactComponent };